import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RadioGroup } from 'formik-mui';

export const Styled = {
    RadioGroup: styled(RadioGroup)(({ theme }) => {
        return {
            display: 'flex',
            flexDirection: 'column',

            '.fancy-radio': {
                width: '100%',
            },
            [theme.breakpoints.down('sm')]: {
                '.fancy-radio': {
                    marginBottom: theme.spacing(2),
                },
            },
            [theme.breakpoints.up('sm')]: {
                flexDirection: 'row',
                '.fancy-radio': {
                    width: '50%',
                    ':first-of-type': {
                        width: `calc(50% - ${theme.spacing(2)})`,
                        marginRight: theme.spacing(2),
                    },
                },
            },
        };
    }),
    Radio: styled(Box)(({ theme }) => {
        return {
            borderRadius: theme.spacing(1.5),
            padding: theme.spacing(2),
            background: theme.palette.background.paper,
            border: '1px solid',
            borderColor: theme.palette.border.main,
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            position: 'relative',
            overflow: 'hidden',
            transition: theme.transitions.create(
                ['border-color', 'background-color'],
                {
                    duration: theme.transitions.duration.shortest,
                },
            ),

            '&:hover': {
                borderColor: theme.palette.border.strong,
            },
            '&.active': {
                borderColor: theme.palette.primary.main,
                backgroundColor: theme.palette.action.selected,
            },
            '.MuiTypography-root': {
                fontFamily: 'YekanBalkhHeavy',
                color: theme.palette.text.primary,
            },
            '.MuiFormControlLabel-root': {
                margin: '0',
                width: '100%',
                height: '100%',

                '.MuiButtonBase-root': {
                    padding: '0',
                    position: 'absolute',
                    right: theme.breakpoints.up('xs')
                        ? theme.spacing(2)
                        : theme.spacing(4),
                    left: 0,
                    top: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'flex-end',

                    input: {
                        position: 'absolute',
                        opacity: 0,
                        width: '100%',
                        height: '100%',
                        top: 0,
                        right: 0,
                        Left: 0,
                        margin: 0,
                        padding: 0,
                    },
                },
            },
        };
    }),
    Icon: styled(Box)(({ theme }) => {
        return {
            marginRight: theme.spacing(3),
            color: theme.palette.text.secondary,
            position: 'relative',
            i: {
                fontSize: '20px',
                transform: 'translateY(3px)',
            },
        };
    }),
    RadioIcon: styled(Box)(({ theme }) => {
        return {
            width: '27px',
            height: '27px',
            border: '2px solid',
            borderColor: theme.palette.border.strong,
            borderRadius: '100%',
            overflow: 'hidden',
        };
    }),
    RadioCheckedIcon: styled(Box)(({ theme }) => {
        return {
            width: '100%',
            height: '100%',
            background: theme.palette.primary.main,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            i: {
                color: theme.palette.primary.contrastText,
            },
        };
    }),
};
